export function isMobile() {
  // 优先判断是否有触控能力（移动端核心特征）
  if (typeof window !== 'undefined' && window.navigator?.maxTouchPoints) {
    // 移动端设备通常有触控点（maxTouchPoints > 0），PC端一般为0
    if (window.navigator.maxTouchPoints > 0) {
      // 排除平板（可选：如果需要区分平板和手机，可加屏幕宽度判断）
      const screenWidth = window.innerWidth || document.documentElement.clientWidth;
      // 手机屏幕宽度通常小于768px（可根据业务调整阈值）
      if (screenWidth < 768) {
        return true;
      }
    }
  }

  // 兜底：优化后的userAgent正则匹配
  if (typeof navigator === 'undefined') return false; // 非浏览器环境（如SSR）
  const userAgent = (navigator.userAgent || navigator.vendor || window.opera || '').toLowerCase();

  // 扩展关键词：覆盖国产浏览器、新版移动端标识
  const mobileKeywords = [
    'android', 'avantgo', 'blackberry', 'bada/', 'bb', 'meego', 'fennec',
    'iphone', 'ipad', 'ipod', 'iemobile', 'kindle', 'midp', 'mmp', 'mobile',
    'o2', 'opera mini', 'palm', 'phone', 'pocket', 'psp', 'symbian', 'smartphone',
    'samsung', 'series', 'sonyericsson', 'treo', 'up.browser', 'up.link',
    'vodafone', 'wap', 'windows ce', 'xda', 'xiino',
    // 补充国产浏览器/设备关键词
    'miui', 'huawei', 'vivo', 'oppo', 'xiaomi', 'meizu', 'qqbrowser', 'ucbrowser',
    'chromemobile', 'mobile safari', 'androidwebkit', 'mobilemozilla'
  ];

  // 匹配任意一个移动端关键词
  return mobileKeywords.some(keyword => userAgent.includes(keyword));
}

export function isIOS() {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /iphone|ipad|ipod/i.test(userAgent);
}

export function isIOSPC() {
  // 获取平台信息
  const platform = navigator.platform;
  
  // 获取用户代理字符串
  const userAgent = navigator.userAgent.toLowerCase();
  
  // 检测是否为Mac平台
  const isMac = /Mac|MacIntel|MacPPC|Mac68K/.test(platform);
  
  // 排除iOS设备（iPhone, iPad, iPod）
  const isIOS = /iphone|ipad|ipod/.test(userAgent);
  
  // 检测iPadOS桌面模式（iPad在桌面模式下会报告为MacIntel）
  const isIPadDesktop = platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  
  // 判断逻辑：
  // 1. 是Mac平台
  // 2. 不是iOS设备
  // 3. 排除iPad桌面模式（因为它不是真正的Mac）
  return isMac && !isIOS && !isIPadDesktop;
}

export function isWeChatBrowser() {
  let userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes("micromessenger");
}
